class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener("cartdrawer:refresh", function (e) {
      this.doRefresh();
    }.bind(this));
  }

  doRefresh() {
    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      sections: sections,
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          //this.registerCartAttributesListener();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }


  // registerCartAttributesListener() {

  //   const deliverySelect = document.getElementById('delivery_pref');

  //   function updateAttribute(selectedValue) {
  //     let formData = {
  //       'attributes': {
  //         'delivery-preference': selectedValue,
  //       }
  //     };

  //     fetch(window.Shopify.routes.root + 'cart/update.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(formData)
  //     })
  //       .then(response => {
  //         console.log(response.json());
  //       })
  //       .catch((error) => {
  //         console.error('Error:', error);
  //       });
  //   }

  //   deliverySelect.addEventListener('change', function () {
  //     const selectedValue = this.value;
  //     updateAttribute(selectedValue);
  //   });

  //   updateAttribute("door-delivery");

  // }
}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart);
}

// === Discount input lock helpers ===
function getDiscountInputEl() {
  return document.querySelector('#mini-cart__discount-form input[name="discount_code"]');
}
function setDiscountInputValue(val) {
  const el = getDiscountInputEl();
  if (el) el.value = val || '';
}
function lockDiscountInput(code) {
  const el = getDiscountInputEl();
  if (!el) return;
  if (code) el.value = code;
  el.readOnly = true;
  el.classList.add('is-readonly');
}
function unlockDiscountInput() {
  const el = getDiscountInputEl();
  if (!el) return;
  el.readOnly = false;
  el.classList.remove('is-readonly');
}
async function syncDiscountInputLock() {
  const root = (window.Shopify?.routes?.root || '/');
  const cart = await fetch(`${root}cart.js?ts=${Date.now()}`, { headers: { Accept: 'application/json' } }).then(r => r.json());
  
  const applicableCodes = (cart?.discount_codes || []).filter(dc => dc?.applicable);
  const hasCartLevel = Array.isArray(cart?.cart_level_discount_applications) && cart.cart_level_discount_applications.length > 0;
  const hasLineLevel = Array.isArray(cart?.items) && cart.items.some(i =>
    Array.isArray(i.line_level_discount_allocations) && i.line_level_discount_allocations.length > 0
  );

  if (hasCartLevel || hasLineLevel || applicableCodes.length) {
    const display = applicableCodes.map(dc => dc.code).filter(Boolean).join(', ');
    console.log('[discount-lock] applied → lock', { hasCartLevel, hasLineLevel, codes: display });
    lockDiscountInput(display);
  } else {
    console.log('[discount-lock] none applied → unlock & clear');
    unlockDiscountInput();
    // clear stale attempt the browser might have restored on reload
    setDiscountInputValue('');
  }
}

/* === Mini cart discount (lazy-init + invalid-code detection) === */
(() => {
  if (window.__miniCartDiscountInitV5) return;
  window.__miniCartDiscountInitV5 = true;

  const ROOT = (window.Shopify?.routes?.root || '/');
  const SECTION_IDS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  const log = (...a) => console.log('[mini-cart-discount]', ...a);

  const getForm = () => {
    const form = document.querySelector('#mini-cart__discount-form');
    return form ? {
      form,
      input: form.querySelector('input[name="discount_code"]'),
      applyBtn: form.querySelector('[data-apply-discount]'),
      removeBtn: form.querySelector('[data-remove-discount]'),
      msg: form.querySelector('.mini-cart__discount-error')
    } : {};
  };

  const hasAnyDiscountDOM = () =>
    !!document.querySelector(
      '.taxes-discounts .discounts__discount, ' + // footer (cart-level)
      '.mini-cart__inner .discounts__discount'    // per-item (line-level)
    );

  const updateButtons = () => {
    const { applyBtn, removeBtn } = getForm();
    const hasAny = hasAnyDiscountDOM();
    if (applyBtn) applyBtn.hidden = !!hasAny;
    if (removeBtn) removeBtn.hidden = !hasAny;
    log('UI toggle → hasAnyDiscount?', hasAny);
  };

  async function renderSections(sections) {
    if (!sections) return;
    for (const [id, html] of Object.entries(sections)) {
      const t = document.querySelector(`[data-section-id="${id}"]`) || document.getElementById(id);
      if (!t) { log('section target not found:', id); continue; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.shopify-section')?.innerHTML || html;
      t.innerHTML = inner;
    }
    updateButtons();
  }

  async function fetchCart() {
    const res = await fetch(`${ROOT}cart.js?ts=${Date.now()}`, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    const json = await res.json();
    const cart = Array.isArray(json) ? { items: json } : json;
    log('cart.js snapshot', {
      total_discount: cart?.total_discount,
      discount_codes: cart?.discount_codes,
      cart_level_discount_applications: cart?.cart_level_discount_applications
    });
    return cart;
  }

  function analyzeResult(code, updateJson, cartJson) {
    const lc = (s) => (s || '').toLowerCase();
    const dcList = []
      .concat(updateJson?.discount_codes || [])
      .concat(updateJson?.cart?.discount_codes || [])
      .concat(cartJson?.discount_codes || []);
    const dc = dcList.find(d => lc(d?.code) === lc(code)) || dcList[0];

    const cartLevel = Array.isArray(cartJson?.cart_level_discount_applications) && cartJson.cart_level_discount_applications.length > 0;
    const lineLevel =
      (Array.isArray(updateJson?.items) && updateJson.items.some(i => (i?.line_level_discount_allocations || []).length > 0)) ||
      (Array.isArray(cartJson?.items) && cartJson.items.some(i => (i?.line_level_discount_allocations || []).length > 0));

    const applied = cartLevel || lineLevel;
    let reason = 'unknown';
    if (applied) reason = 'applied';
    else if (dc && dc.applicable === false) reason = 'inapplicable';
    else if (dc && dc.applicable === true) reason = 'shipping-only-or-later';
    else reason = 'notfound';

    log('analyze →', { code, applied, reason, dc });
    return { applied, reason };
  }

  async function applyAjaxDiscount(code) {
    const payload = { discount: code, sections: SECTION_IDS, sections_url: '/cart' };
    log('→ /cart/update.js', payload);

    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    const updateJson = await res.json();
    await renderSections(updateJson.sections);
    const cartJson = await fetchCart();
    return analyzeResult(code, updateJson, cartJson);
  }

  // Initialize only when the drawer actually injects content
  function initHandlersOnce() {
    if (initHandlersOnce._done) return;
    initHandlersOnce._done = true;
    log('init (lazy after cartdrawer:opened)');

    // Optional: ensure checkout remembers the code too
    function seedCheckoutCookie(code) {
      if (!code) return;
      const url = `${ROOT}discount/${encodeURIComponent(code)}?redirect=/cart`;
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      iframe.onload = () => iframe.remove();
      document.body.appendChild(iframe);
    }

    // Apply discount button click handler
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('#mini-cart__discount-form [data-apply-discount]');
      if (!btn) return;
      e.preventDefault();

      const { form, input } = getForm();
      const code = (input?.value || '').trim();
      if (!code) return;

      const pre = getForm().msg;
      if (pre) { pre.hidden = true; pre.textContent = ''; }
      form?.classList.add('is-loading');

      try {
        const { applied, reason } = await applyAjaxDiscount(code);

        // Re-acquire message after the drawer re-rendered
        const { msg } = getForm();
        if (applied) {
          if (msg) { msg.hidden = true; msg.textContent = ''; }
          lockDiscountInput(code);
          // Belt & suspenders: seed checkout session with the code
          seedCheckoutCookie(code);
        } else {
          if (msg) {
            msg.hidden = false;
            msg.textContent =
              (reason === 'shipping-only-or-later')
                ? `${code} is saved and will apply at checkout (e.g., shipping discount).`
                : `Oops! add more products / some products may not qualify`;
          }
        }
      } catch (err) {
        console.error('[mini-cart-discount] apply error', err);
        const { msg } = getForm();
        if (msg) { msg.hidden = false; msg.textContent = 'Something went wrong — please try again.'; }
      } finally {
        const { form } = getForm();
        form?.classList.remove('is-loading');
        updateButtons();
      }
    });

    // Remove
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('#mini-cart__discount-form [data-remove-discount]');
      if (!btn) return;
      e.preventDefault();

      const pre = getForm().msg;
      if (pre) { pre.hidden = true; pre.textContent = ''; }
      try {
        await applyAjaxDiscount('');
        const { input } = getForm();
        if (input) input.value = '';
      } catch (err) {
        console.error('[mini-cart-discount] remove error', err);
      } finally {
        updateButtons();
        unlockDiscountInput();
      }
    });

    // Keep UI in sync whenever your drawer re-renders its sections
    document.addEventListener('cart:updated', updateButtons);
    document.addEventListener('cartdrawer:opened', updateButtons);
    const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
    if (drawer && 'MutationObserver' in window) {
      const obs = new MutationObserver(updateButtons);
      obs.observe(drawer, { childList: true, subtree: true });
    }

    updateButtons();
  }

  // 🔑 Defer setup until the drawer injects content
  document.addEventListener('cartdrawer:opened', initHandlersOnce, { once: true });
  document.addEventListener('cart:updated', syncDiscountInputLock);
  document.addEventListener('cartdrawer:opened', syncDiscountInputLock);
})();

/* === Suggested coupon → auto-fill + apply + hide suggestions === */
(() => {
  if (window.__cartDrawerSuggestedCouponInit) return;
  window.__cartDrawerSuggestedCouponInit = true;

  const log = (...a) => console.log('[suggested-coupon]', ...a);

  function getDiscountInput() {
    return document.querySelector('#mini-cart__discount-form input[name="discount_code"]');
  }
  function getApplyButton() {
    return document.querySelector('#mini-cart__discount-form [data-apply-discount]');
  }
  function hideSuggestions(scope) {
    const root = scope || document;
    root.querySelectorAll('.cart-drawer__discounts-wrapper2').forEach((el) => {
      // el.setAttribute('hidden', 'true');         // prefer attribute so CSS can key off it
      el.classList.add('is-hidden');             // optional: for themes that use classes
    });
  }
  function hasAnyDiscountDOM() {
    // Works for both cart-level (footer) and line-level (per item) discounts
    return !!document.querySelector(
      '.taxes-discounts .discounts__discount, .mini-cart__inner .discounts__discount'
    );
  }

  // 1) Handle clicks on the suggested coupon button (delegated)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer__discount-button');
    if (!btn) return;

    e.preventDefault();

    // Find the code near the clicked button
    const localContainer =
      btn.closest('.cart-drawer__discount-card') ||
      btn.closest('.cart-drawer__discounts-wrapper') ||
      btn.parentElement;

    const codeEl =
      (localContainer && localContainer.querySelector('.cart-drawer__discount-code')) ||
      document.querySelector('.cart-drawer__discount-code');

    const code = (codeEl?.textContent || '').trim();
    if (!code) {
      log('No code found near button click.');
      return;
    }

    // Fill the mini-cart input
    const input = getDiscountInput();
    if (!input) { log('Discount input not found in mini cart.'); return; }
    input.value = code;

    // Trigger your existing Apply flow
    const applyBtn = getApplyButton();
    if (applyBtn) {
      applyBtn.click();
      log('Applied suggested code:', code);
    } else {
      // Fallback: fire a synthetic click for delegated handlers
      const target = document.querySelector('#mini-cart__discount-form [data-apply-discount]');
      if (target) {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        log('Applied via delegated event:', code);
      } else {
        log('Apply button not found.');
      }
    }

    // Hide suggestions immediately
    hideSuggestions(localContainer || document);
    // Remember we hid them (so we can hide again after re-render)
    document.documentElement.dataset.suggestionsHidden = '1';
  });


  // 2) New version: Handle clicks on the suggested coupon button (delegated)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-drawer__discount-code');
    if (!btn) return;

    e.preventDefault();

    const code = (btn?.textContent || '').trim();
    if (!code) {
      log('No code found near button click.');
      return;
    }

    // Fill the mini-cart input
    const input = getDiscountInput();
    if (!input) { log('Discount input not found in mini cart.'); return; }
    input.value = code;

    // Trigger your existing Apply flow
    const applyBtn = getApplyButton();
    if (applyBtn) {
      applyBtn.click();
      log('Applied suggested code:', code);
    } else {
      // Fallback: fire a synthetic click for delegated handlers
      const target = document.querySelector('#mini-cart__discount-form [data-apply-discount]');
      if (target) {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        log('Applied via delegated event:', code);
      } else {
        log('Apply button not found.');
      }
    }

    // Hide suggestions immediately
    hideSuggestions(localContainer || document);
    // Remember we hid them (so we can hide again after re-render)
    document.documentElement.dataset.suggestionsHidden = '1';
  });

  // 2) After cart re-renders / drawer opens, keep suggestions hidden if a discount is present or we already hid them
  const keepHidden = () => {
    if (document.documentElement.dataset.suggestionsHidden === '1' || hasAnyDiscountDOM()) {
      hideSuggestions(document);
      log('Suggestions kept hidden after refresh.');
    }
  };

  document.addEventListener('cart:updated', keepHidden);
  document.addEventListener('cartdrawer:opened', keepHidden);

  // 3) Also react to DOM swaps inside the drawer (lazy-loaded content)
  const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
  if (drawer && 'MutationObserver' in window) {
    const obs = new MutationObserver(() => keepHidden());
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();

/* === Suggested codes (rules + priority, max 2) === */
(() => {
  if (window.__suggestedCodesFilterInit) return;
  window.__suggestedCodesFilterInit = true;

  const log = (...a) => console.log('[suggested-codes]', ...a);
  const ROOT = (window.Shopify?.routes?.root || '/');

  async function getCart() {
    const res = await fetch(`${ROOT}cart.js?ts=${Date.now()}`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    });
    const raw = await res.json();
    return Array.isArray(raw) ? { items: raw, items_subtotal_price: 0 } : raw;
  }

  function cartHasVariant(cart, variantId) {
    const id = parseInt(variantId, 10);
    return (cart.items || []).some(it => it.variant_id === id);
  }

  function hide(el) {
    el.setAttribute('hidden', 'true');
    el.classList.add('is-hidden');
  }
  function show(el) {
    el.removeAttribute('hidden');
    el.classList.remove('is-hidden');
  }

  function evaluateOne(el, cart) {
    const code = (el.dataset.code || '').trim();
    const priority = parseInt(el.dataset.priority || '0', 10) || 0;
    const always = el.dataset.always === 'true';

    const min = el.dataset.minTotal ? parseInt(el.dataset.minTotal, 10) : null; // minor units
    const max = el.dataset.maxTotal ? parseInt(el.dataset.maxTotal, 10) : null; // minor units
    const reqVar = el.dataset.requiresVariant ? el.dataset.requiresVariant : null;

    const subtotal = cart.items_subtotal_price ?? 0;

    let ok = true;
    const reasons = [];

    if (always) {
      // still allow other constraints if you add them later
    }
    if (min !== null && subtotal < min) { ok = false; reasons.push(`subtotal<min(${min})`); }
    if (max !== null && subtotal > max) { ok = false; reasons.push(`subtotal>max(${max})`); }
    if (reqVar && !cartHasVariant(cart, reqVar)) { ok = false; reasons.push(`missingVariant(${reqVar})`); }

    log('check', { code, priority, subtotal, min, max, reqVar, eligible: ok, reasons });
    return { el, code, priority, eligible: ok, reasons };
  }

  async function runFilter() {
    const wrapper = document.querySelector('.cart-drawer__discounts-wrapper2');
    if (!wrapper) return;

    const blocks = Array.from(wrapper.querySelectorAll('.cart-drawer__discount-code-container2'));
    if (!blocks.length) return;

    const cart = await getCart();

    // Evaluate
    const evaluated = blocks.map(el => evaluateOne(el, cart));

    // Sort eligible by priority (desc), fallback to DOM order
    const eligible = evaluated
      .filter(x => x.eligible)
      .sort((a, b) => (b.priority - a.priority));

    // Show top 2, hide the rest
    const toShow = eligible.slice(0, 2).map(x => x.el);
    const toHide = new Set(blocks);
    toShow.forEach(el => toHide.delete(el));
    toShow.forEach(el => { show(el); log('show', el.dataset.code); });
    toHide.forEach(el => { hide(el); if (el.dataset.code) log('hide', el.dataset.code); });

    log('summary', {
      subtotal: cart.items_subtotal_price,
      shown: toShow.map(el => el.dataset.code || '(no-code)'),
      hidden: Array.from(toHide).map(el => el.dataset.code || '(no-code)')
    });
  }

  // Re-run when the drawer opens and when cart updates
  document.addEventListener('cartdrawer:opened', runFilter);
  document.addEventListener('cart:updated', runFilter);

  // Also react to DOM swaps inside the drawer
  const drawer = document.querySelector('cart-drawer, .cart-drawer, mini-cart');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(() => runFilter()).observe(drawer, { childList: true, subtree: true });
  }

  // First pass
  runFilter();
})();

/* 31799282466887 */

/* === Free Gift Offer (2-minute timer, hardcoded conditions) — DEBUG BUILD === */
/*
(() => {
  if (window.__freeGiftInit) {
    console.log('[free-gift] already initialized');
    return;
  }
  window.__freeGiftInit = true;

  const ROOT = (window.Shopify?.routes?.root || '/');
  const SECTION_IDS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  const log = (...a) => console.log('[free-gift]', ...a);

  // ---------- CONFIG ----------
  const GIFT_CONFIG = {
    variantId: 31799282466887,         // FASTEST: hardcode the free gift variant ID
    handle: null,                      // or set a handle like 'my-gift' and leave variantId null
    properties: { _free_gift: 'true' },
    couponCode: 'MARCOFREE'                   // e.g. 'FREEGIFT' if you zero the item with a code
  };

  // Example rule: subtotal >= ₹5,000 and gift not already in cart
  function evaluateEligibility(cart) {
    const threshold = 500000; // ₹5,000 in smallest currency unit
    const reasons = [];
    const hasGiftLine = (cart.items || []).some(i =>
      (i.properties && i.properties._free_gift === 'true') ||
      (GIFT_CONFIG.variantId && i.variant_id === GIFT_CONFIG.variantId)
    );
    if (hasGiftLine) reasons.push('gift-already-in-cart');
    if ((cart.items_subtotal_price || 0) < threshold) reasons.push('subtotal-below-threshold');
    const show = !hasGiftLine && (cart.items_subtotal_price >= threshold);
    return { show, reasons, hasGiftLine, threshold };
  }
  // ---------- /CONFIG ----------

  // Utils
  const getGiftRoot = () => document.querySelector('#free-gift-offer');
  const now = () => Date.now();

  async function fetchCart() {
    const url = `${ROOT}cart.js?ts=${Date.now()}`;
    log('fetchCart →', url);
    const res = await fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    const raw = await res.json();
    const cart = Array.isArray(raw) ? { items: raw } : raw;
    log('fetchCart ←', {
      items: cart?.items?.length || 0,
      items_subtotal_price: cart?.items_subtotal_price,
      total_discount: cart?.total_discount,
      discount_codes: cart?.discount_codes
    });
    return cart;
  }

  async function refreshSections() {
    const url = `${ROOT}?sections=${SECTION_IDS.join(',')}&ts=${Date.now()}`;
    log('refreshSections →', url);
    try {
      const txt = await fetch(url, { credentials: 'same-origin' }).then(r => r.text());
      const json = JSON.parse(txt);
      let replaced = 0;
      for (const id of SECTION_IDS) {
        const html = json[id];
        if (!html) { log('refreshSections (missing section):', id); continue; }
        const target =
          document.querySelector(`[data-section-id="${id}"]`) ||
          document.getElementById(id);
        if (!target) { log('refreshSections (no target):', id); continue; }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.shopify-section')?.innerHTML || html;
        target.innerHTML = inner;
        replaced++;
      }
      log('refreshSections ← replaced', replaced, 'sections');
    } catch (e) {
      console.warn('[free-gift] refreshSections failed', e);
    }
  }

  async function resolveVariantIdFromHandle(handle) {
    const url = `${ROOT}products/${encodeURIComponent(handle)}.js`;
    log('resolveVariantIdFromHandle →', url);
    const p = await fetch(url, { credentials: 'same-origin' }).then(r => r.json());
    const id = p?.variants?.[0]?.id || null;
    log('resolveVariantIdFromHandle ←', { resolvedVariantId: id, title: p?.title });
    return id;
  }

  async function fetchVariant(variantId) {
    const url = `${ROOT}variants/${variantId}.js`;
    log('fetchVariant →', url);
    const v = await fetch(url, { credentials: 'same-origin' }).then(r => r.json());
    log('fetchVariant ←', { variantTitle: v?.title, productTitle: v?.product?.title });
    return v;
  }

  async function addGiftToCart(variantId) {
    const body = {
      items: [{ id: variantId, quantity: 1, properties: GIFT_CONFIG.properties || { _free_gift: 'true' } }]
    };
    const url = `${ROOT}cart/add.js`;
    log('addGiftToCart →', url, body);
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    const json = await res.json().catch(() => ({}));
    log('addGiftToCart ←', res.status, json);
    if (!res.ok) throw new Error(`add failed: ${res.status}`);
    return json;
  }

  function seedCoupon(code) {
    if (!code) return;
    const url = `${ROOT}discount/${encodeURIComponent(code)}?redirect=/cart`;
    log('seedCoupon →', url);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = () => { iframe.remove(); log('seedCoupon ← loaded'); };
    document.body.appendChild(iframe);
  }

  async function applyCombinedDiscounts(extraCode) {
    if (!extraCode) { log('applyCombinedDiscounts: no code, skip'); return; }
    const cart = await fetch(`${ROOT}cart.js?ts=${Date.now()}`, {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    }).then(r => r.json());
    const existing = (cart?.discount_codes || []).map(d => (d?.code || '').trim()).filter(Boolean);
    const merged = Array.from(new Set([...existing, extraCode])).join(',');
    log('applyCombinedDiscounts →', { existing, extraCode, merged });
    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: merged,
        sections: ['mini-cart','cart-icon-bubble','mobile-cart-icon-bubble'],
        sections_url: '/cart'
      })
    });
    const json = await res.json().catch(() => ({}));
    log('applyCombinedDiscounts ←', res.status, {
      cart_level_discount_applications: json?.cart_level_discount_applications,
      items_updated: json?.items?.length
    });
  }

  // Countdown state (persist by cart token)
  const getCartKey = (cart) => cart?.token ? `cws_fg_${cart.token}` : 'cws_fg_session';
  const getExpiry  = (key) => parseInt(localStorage.getItem(`${key}_exp`) || '0', 10);
  const setExpiry  = (key, ts) => localStorage.setItem(`${key}_exp`, String(ts));
  const setDismiss = (key) => localStorage.setItem(`${key}_dismissed`, '1');
  const wasDismiss = (key) => localStorage.getItem(`${key}_dismissed`) === '1';
  const setAccept  = (key) => localStorage.setItem(`${key}_accepted`, '1');
  const wasAccept  = (key) => localStorage.getItem(`${key}_accepted`) === '1';

  function renderOffer(vm) {
    const el = getGiftRoot();
    if (!el) { log('renderOffer: #free-gift-offer not found'); return; }
    el.innerHTML = `
      <div class="free-gift">
        <div class="free-gift__media">${vm.image ? `<img src="${vm.image}" alt="">` : ''}</div>
        <div class="free-gift__content">
          ${vm.variantTitle ? `<div class="free-gift__variant">${vm.variantTitle}</div>` : ''}
          <div class="free-gift__product">${vm.productTitle || ''}</div>
          <div class="free-gift__timer" data-free-gift-timer></div>
        </div>
        <div class="free-gift__actions">
          <button type="button" class="free-gift__add-btn">Claim</button>
          <!-- <button type="button" class="free-gift__dismiss-btn">No, thanks</button> -->
        </div>
      </div>`;
    el.hidden = false;
    log('renderOffer: shown');
  }

  function hideOffer() {
    const el = getGiftRoot();
    if (el) { el.hidden = true; el.innerHTML = ''; }
    log('hideOffer');
  }

  function startCountdown(expiryTs) {
    log('countdown start →', new Date(expiryTs).toISOString());
    const tick = () => {
      const t = getGiftRoot()?.querySelector('[data-free-gift-timer]');
      if (!t) return;
      const rem = Math.max(0, expiryTs - now());
      const sec = Math.ceil(rem / 1000);
      const mm = String(Math.floor(sec / 60)).padStart(2, '0');
      const ss = String(sec % 60).padStart(2, '0');
      t.textContent = rem > 0 ? `Offer expires in ${mm}:${ss}` : `Offer expired`;
      if (rem <= 0) {
        const addBtn = getGiftRoot()?.querySelector('.free-gift__add-btn');
        if (addBtn) addBtn.disabled = true;
        clearInterval(intv);
        log('countdown ended');
      }
    };
    tick();
    const intv = setInterval(tick, 1000);
    return () => { clearInterval(intv); log('countdown canceled'); };
  }

  function bindOfferEvents({ variantId, couponCode, storeKey }) {
    const root = getGiftRoot();
    if (!root) return;
    if (root.dataset.bound === '1') { log('bindOfferEvents: already bound'); return; }
    root.dataset.bound = '1';
    log('bindOfferEvents: attached');

    root.addEventListener('click', async (e) => {
      const addBtn = e.target.closest('.free-gift__add-btn');
      const dismissBtn = e.target.closest('.free-gift__dismiss-btn');
      if (!addBtn && !dismissBtn) return;
      e.preventDefault();

      if (dismissBtn) {
        setDismiss(storeKey);
        log('dismiss clicked');
        hideOffer();
        return;
      }

      if (addBtn) {
        const exp = getExpiry(storeKey);
        if (now() > exp) {
          log('add clicked but offer expired');
          const t = getGiftRoot()?.querySelector('[data-free-gift-timer]');
          if (t) t.textContent = 'Offer expired';
          return;
        }

        addBtn.disabled = true;
        try {
          await addGiftToCart(variantId);
          if (couponCode) await applyCombinedDiscounts(couponCode);
          setAccept(storeKey);
          hideOffer();
          await refreshSections();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          log('add success → sections refreshed + cart:updated');
        } catch (err) {
          console.error('[free-gift] add failed', err);
          addBtn.disabled = false;
        }
      }
    });
  }

  async function buildGiftVM(cart) {
    let variantId = GIFT_CONFIG.variantId;
    if (!variantId && GIFT_CONFIG.handle) {
      variantId = await resolveVariantIdFromHandle(GIFT_CONFIG.handle);
    }
    if (!variantId) { log('buildGiftVM: no variantId could be resolved'); return null; }

    let v = null;
    try { 
      v = await fetchVariant(variantId);
      log('fetchVariant result', v); 
    } catch (e) { 
      log('fetchVariant error', e); 
    }

    const vm = {
      variantId,
      couponCode: GIFT_CONFIG.couponCode || null,
      productTitle: v?.product?.title || 'Free Gift for You',
      variantTitle: v?.title || '',
      image: v?.featured_image?.src || ''
    };
    log('buildGiftVM ←', vm);
    return vm;
  }

  let running = false; // reentrancy guard

  async function maybeShowGift() {
    if (running) { log('maybeShowGift: skip (already running)'); return; }
    running = true;
    log('maybeShowGift: start');

    try {
      const giftRoot = getGiftRoot();
      if (!giftRoot) { log('maybeShowGift: #free-gift-offer not in DOM'); return; }

      const cart = await fetchCart();
      const key = getCartKey(cart);
      log('session key →', key, { accepted: wasAccept(key), dismissed: wasDismiss(key) });

      if (wasAccept(key) || wasDismiss(key)) { hideOffer(); return; }

      const { show, reasons, hasGiftLine, threshold } = evaluateEligibility(cart);
      log('eligibility →', { show, reasons, subtotal: cart.items_subtotal_price, threshold, hasGiftLine });

      if (!show) { hideOffer(); return; }

      const vm = await buildGiftVM(cart);
      if (!vm) { hideOffer(); return; }

      // Setup / resume countdown
      const DURATION_MS = 20 * 60 * 1000;
      let expiry = getExpiry(key);
      if (!expiry || expiry < now()) {
        expiry = now() + DURATION_MS;
        setExpiry(key, expiry);
        log('expiry set →', new Date(expiry).toISOString());
      } else {
        log('expiry resumes →', new Date(expiry).toISOString());
      }

      renderOffer(vm);
      const cancel = startCountdown(expiry);
      bindOfferEvents({ variantId: vm.variantId, couponCode: vm.couponCode, storeKey: key });

      // stop countdown if node removed/hidden
      const obs = new MutationObserver(() => {
        const el = getGiftRoot();
        if (!el || el.hidden) { cancel(); obs.disconnect(); }
      });
      obs.observe(document, { childList: true, subtree: true });
    } catch (e) {
      console.warn('[free-gift] maybeShowGift error', e);
    } finally {
      running = false;
      log('maybeShowGift: end');
    }
  }

  const kickoff = () => { log('kickoff'); maybeShowGift().catch(e => console.warn('[free-gift] error', e)); };
  document.addEventListener('cartdrawer:opened', kickoff);
  document.addEventListener('cart:updated', kickoff);

  // Try once immediately (in case drawer HTML already exists)
  kickoff();
})();
*/